<template>
    <div class=" d-flex align-items-center">
        <font-awesome-layers
            fixed-width
            :class="small ? 'fa-lg' : 'fa-2x'">
            <font-awesome-icon
                icon="shopping-cart"
                :class="{'text-muted': requestedBookingCount <= 0}" />
            <font-awesome-layers
                v-show="requestedBookingCount > 0"
                :key="requestedBookingCount"
                ref="shake"
                fixed-width>
                <font-awesome-icon
                    icon="circle"
                    class="text-primary"
                    transform="down-6 right-8 shrink-4" />
                <font-awesome-layers-text
                    class="font-weight-bold text-white"
                    transform="down-5 right-8 shrink-9"
                    :value="requestedBookingCount" />
            </font-awesome-layers>
        </font-awesome-layers>
    </div>
</template>

<script>

import resourceBookingsMixin from "@/mixins/resourceBookingsMixin";

export default {
    name: "BookingCart",
    mixins: [resourceBookingsMixin],
    props: {
        small: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            startVal: 0
        }
    },
    methods: {
        shake(pulseElement = this.$refs.shake) {
            pulseElement.classList?.add("shake")
            setTimeout(() => {
                pulseElement.classList?.remove("shake")
            }, 821)
        }
    },
    watch: {
        requestedBookingCount: {
            handler(val) {
                if (val > 0) {
                    this.shake()
                }
            }
        }
    }
}
</script>

<style scoped>
</style>
